module.exports = __webpack_public_path__ + "static/media/lekta_logo.svg?3db1675ce68961483325c75aa7e7b816";